export const API_URL = process.env.REACT_APP_AUTH0_DOMAIN!;

export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID!;
export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE!;
export const GRANT_TYPE = "client_credentials";

export const SPA_CLIENT_ID = process.env.REACT_APP_SPA_CLIENT_ID!;
export const SPA_DOMAIN = process.env.REACT_APP_SPA_DOMAIN!;
export const CID = process.env.REACT_APP_CID!;

export const PROXY_API_URL = process.env.REACT_APP_PROXY_API_URL!;
export const API_SURVEY_URL = process.env.REACT_APP_API_SURVEY_URL!;
export const API_ADDRESS_URL = process.env.REACT_APP_API_ADDRESS_URL!;

export const EVENT_API_URL = process.env.REACT_APP_EVENT_API_URL!;
export const EVENT_API_URL_SAME_SUB_DOMAIN = process.env.REACT_APP_EVENT_API_URL_SAME_SUB_DOMAIN!;

export const SURVEY_API_URL = process.env.REACT_APP_SURVEY_API_URL!;
export const SPA_EVENT_WEB = process.env.REACT_APP_SPA_EVENT_WEB!;
export const MICRO_CMS_API = process.env.REACT_APP_MICRO_CMS_API!;
export const SSO_SYNC_API = process.env.REACT_APP_SSO_SYNC_API!;
export const X_API_KEY = process.env.REACT_APP_X_API_KEY!;
export const TRANSITION_SOURCE_CONFIG = {
    ADTAI: {
        value: "advertimes",
        domains: ["advertimes.com"],
    },
};
